export const getContentLocation = (state: WtrState, resourcePath: string, location: string) =>
  state.cmsContentSlice?.[resourcePath]?.find(({ locationName }) => locationName === location)
    ?.childComponents;
